import React, { Component } from 'react';
import Loading from '../../Loading.js'
import ControlDocuments from './ControlDocuments.js';
import { getProjectDocuments } from '../../../Api/ExtranetActions.js';

declare var globalSns;

class ExtranetProjectsDocuments extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getProjectDocuments(this.props.id, globalSns.languageId, (data) => {
            this.setState({
                projectDocuments: data
            });
        });
    }

    render() {
        if (this.state.projectDocuments == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <ControlDocuments documents={this.state.projectDocuments} 
                        onNavigateToCandidates={(row) => this.props.onNavigate("extranetCandidatesFiche", row.personId, row.personFirstName + " " + row.personName)}
                        showDocumentType={true}
                        filterDocumentType={this.props.data} />
                </div>
            </div>
        );
    }
}

export default ExtranetProjectsDocuments;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetProjectsDocuments.js